import quickfireModel from "quickfire/model/quickfire-model";
import BetModel from "slotworks/model/bets/bet-model";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import SmartUIManager from "slotworks/smart-ui/smart-ui-manager";
import Contract from "slotworks/utils/contracts/contract";
export function QuickfireForceChipSizeCommand() {
    return new Contract<void>((resolve) => {
        if (quickfireModel.forcedChipSize) {
            V.API.Dialog.showCoinSizeChangedDialog(resolve);

            const options = new ControlOptions();
            BetModel.injectBetOptions(options);
            options.creditSizes.currentValue = quickfireModel.forcedChipSize;
            BetModel.updateFromOptions(options);

            quickfireModel.forcedChipSize = 0;

            SmartUIManager.refresh();
        } else {
            resolve(null);
        }
    });
}
